import { addDays, isSameMonth } from "date-fns";

export class HelperFunctions {
  public static round(value: any) {
    if (!value) return 0;
    const v = parseFloat(value);
    return (Math.round(v * 10) / 10).toFixed(1);
  }

  public static dumpVariable(obj: any, label?: string) {
    try {
      console.log(label, JSON.parse(JSON.stringify(obj)));
    } catch (e: any) {
      console.error(e);
    }
  }

  public static isEmpty(obj: any) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return true;
  }

  public static displayDate(value: any, type: number) {
    if (!value) return value;
    const d = new Date(value);
    switch (type) {
      default:
      case 0: // daily
        return d.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric"
        });
      case 1: // weekly
        const date1 = d;
        const date2 = addDays(d, 6);
        return isSameMonth(date1, date2)
          ? `${date1.getDate()} - ${date2.getDate()} ${d.toLocaleDateString("en-GB", {
              month: "short",
              year: "numeric"
            })}`
          : `${date1.getDate()} ${d.toLocaleDateString("en-GB", {
              month: "short"
            })} - ${date2.getDate()} ${date2.toLocaleDateString("en-GB", {
              month: "short",
              year: "numeric"
            })}`;
      case 2: // monthly
        return d.toLocaleDateString("en-GB", {
          month: "long",
          year: "numeric"
        });
      case 10: // display for date-time pickers
        return `${d.getUTCDate()}-${d.getUTCMonth()}-${d.getUTCFullYear()}`;
    }
  }
}
